import { feedPageUrl } from '@ms/yammer-web-support/dist/urls';
import React, { FC } from 'react';
import { Redirect } from 'react-router';

const RedirectToFeed: FC = () => <Redirect to={feedPageUrl} />;

export default RedirectToFeed;
